var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"user-img"},[_c('img',{attrs:{"src":_vm._f("getAvator")(_vm.avatar)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }